/*
** $Id$
**
** Copyright 2018-2019 Port25 Solutions, Inc.
** All rights reserved.
*/


import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { updateComponent, getFromJson, formatPercent, formatBoolean }
         from '../util/Utils'
import Table from './Table';
import PropTypes from 'prop-types';
import { LONG_REFRESH_INTERVAL } from '../constants'
var homepage = require('../../package.json').homepage;


function makeTableData(state) {
    return {
        domain: {
            columns: ["Name", "#Rcpt", "#KBytes", "#Conn"],
            data: makeDomainDetail(state),
            title: "Domain Detail",
            queues: {
                columns: ["VMTA", "#Rcpt", "#KBytes", "#Conn", "Paused",
                          "Mode", "% Rcpts"],
                data: makeQueues(state),
                title: "Queues"
            },
            errors: {
                columns: ["VMTA", "Time", "Error"],
                data: makeErrors(state),
                title: "Last Errors"
            },
            jobs: {
                columns: ["Name", "#Rcpt"],
                data: makeJobs(state),
                title: "Jobs"
            },
        }
    }
}


function makeDomainDetail(state) {
    let d = getFromJson(state, ['data', 'data', 'domain'])
    return d ? [[d.name, d.rcp, d.kb, d.conn]] : []
}


function makeQueues(state) {
    let queues = getFromJson(state, ['data', 'data', 'domain', 'queues'], [])
    return queues.map((q) => {
        let rcpPct = formatPercent(q.rcp, state.data.data.domain.rcp)
        return [getVmta(q.name), q.rcp, q.kb, q.conn, q.paused, q.mode, rcpPct]
    })
}


function makeJobs(state) {
    let jobs = getFromJson(state, ['data', 'data', 'domain', 'jobs'], [])
    return jobs.map((j) => {
        return [j.id, j.rcp]
    })
}


function makeErrors(state) {
    let errors = getFromJson(state, ['data', 'data', 'domain', 'errors'], [])
    return errors.map((e) => {
        return [getVmta(e.queue), e.time, e.text]
    })
}


// exported for testing.
export function getVmta(queue) {
    if (!queue) {
        return ""
    }
    let slash = queue.indexOf('/')
    if (slash === -1) {
        return ""
    }
    return queue.substring(slash + 1)
}


/**
 * DomainDetail page of web monitor.
 */
export default class DomainDetail extends Component {
    constructor(props) {
        super(props)
        this.vmtaFormatter = this.vmtaFormatter.bind(this)
        this.refresh = this.refresh.bind(this)
        this.refreshInterval = this.refreshInterval.bind(this)
    }


    static propTypes = {
        domain: PropTypes.string.isRequired,
        showError: PropTypes.func.isRequired,
        setRefresh: PropTypes.func.isRequired,
        setRefreshInterval: PropTypes.func.isRequired
    };


    async componentDidMount() {
        this.props.setRefresh(this.refresh)
        this.props.setRefreshInterval(this.refreshInterval)
        this.refresh()
    }


    refresh() {
        updateComponent(this, '/domainDetail', {
            domain: this.props.domain
        })
    }


    refreshInterval() {
        return LONG_REFRESH_INTERVAL
    }


    vmtaFormatter(vmta) {
        return (
            <Link to={`${homepage}/queueDetail/${this.props.domain}/${vmta}`}>
                {vmta}
            </Link>
        )
    }


    jobFormatter(job) {
        return (
            <Link to={`${homepage}/jobDetail/${job}`}>
                {job}
            </Link>
        )
    }


    render() {
        let tables = makeTableData(this.state)
        let formatter = {
            VMTA: this.vmtaFormatter,
            Paused: formatBoolean
        }

        let jobFormatter = {
            Name: this.jobFormatter
        }

        return (
            <Container>
                <Row>
                    <Col md={12}>{
                        <Table columns={tables.domain.columns}
                               data={tables.domain.data}
                               caption={tables.domain.title}/>
                    }</Col>
                </Row>
                <Row>
                    <Col md={12}>{
                        <Table columns={tables.domain.queues.columns}
                               data={tables.domain.queues.data}
                               caption={tables.domain.queues.title}
                               columnFormatter={formatter}
                               sort={true}/>
                    }</Col>
                </Row>
                <Row>
                    <Col md={12}>{
                        <Table columns={tables.domain.errors.columns}
                               data={tables.domain.errors.data}
                               caption={tables.domain.errors.title}
                               columnFormatter={formatter}/>
                    }</Col>
                </Row>
                <Row>
                    <Col md={12}>{
                        <Table columns={tables.domain.jobs.columns}
                               data={tables.domain.jobs.data}
                               caption={tables.domain.jobs.title}
                               columnFormatter={jobFormatter}
                               sort={true}/>
                    }</Col>
                </Row>
            </Container>
        );
    }
}


